export default __webpack_public_path__ + "static/media/lead-1.89ea86ea.png";